import type { ReactNode } from "react";
import { useUserLanguage } from "@/customHooks";
import textsData from "@/textData/EmbedGuardTexts.json";

type EmbedGuardProps = {
  children: ReactNode;
};

const getEmbedParams = (): { propertyId: string | null; token: string | null } => {
  const fromStorage = {
    propertyId: sessionStorage.getItem("propertyId"),
    token: sessionStorage.getItem("inventoryToken"),
  };

  const params = new URLSearchParams(window.location.search);
  return {
    propertyId: params.get("propertyId") || fromStorage.propertyId,
    token: params.get("token") || fromStorage.token,
  };
};

export const EmbedGuard = ({ children }: EmbedGuardProps) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === "es" ? textsData.es : textsData.en;
  const { propertyId, token } = getEmbedParams();

  if (!propertyId) {
    return (
      <main className="flex min-h-screen items-center justify-center p-6">
        <div className="max-w-lg rounded-2xl bg-white p-8 shadow-md text-center">
          <h1 className="text-xl font-semibold text-slate-900">{texts.title}</h1>
          <p className="mt-4 text-sm text-slate-600">{texts.missingPropertyId}</p>
        </div>
      </main>
    );
  }

  if (!token) {
    return (
      <main className="flex min-h-screen items-center justify-center p-6">
        <div className="max-w-lg rounded-2xl bg-white p-8 shadow-md text-center">
          <h1 className="text-xl font-semibold text-slate-900">{texts.title}</h1>
          <p className="mt-4 text-sm text-slate-600">{texts.missingToken}</p>
        </div>
      </main>
    );
  }

  return <>{children}</>;
};
